export default __webpack_public_path__ + "static/3-20daa785564575973b0c0ffb2fa4961f.png";